var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 72,
    viewBox: "0 0 81 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.22875 36.096C0.22875 25.024 2.08475 16.384 5.79675 10.176C9.57275 3.904 16.0368 0.767996 25.1888 0.767996C34.3408 0.767996 40.7728 3.904 44.4848 10.176C48.2608 16.384 50.1488 25.024 50.1488 36.096C50.1488 47.296 48.2608 56.064 44.4848 62.4C40.7728 68.672 34.3408 71.808 25.1888 71.808C16.0368 71.808 9.57275 68.672 5.79675 62.4C2.08475 56.064 0.22875 47.296 0.22875 36.096ZM39.3968 36.096C39.3968 30.912 39.0448 26.528 38.3408 22.944C37.7008 19.36 36.3568 16.448 34.3088 14.208C32.2608 11.904 29.2208 10.752 25.1888 10.752C21.1568 10.752 18.1168 11.904 16.0688 14.208C14.0208 16.448 12.6448 19.36 11.9408 22.944C11.3008 26.528 10.9808 30.912 10.9808 36.096C10.9808 41.472 11.3008 45.984 11.9408 49.632C12.5808 53.28 13.9248 56.224 15.9728 58.464C18.0848 60.704 21.1568 61.824 25.1888 61.824C29.2208 61.824 32.2608 60.704 34.3088 58.464C36.4208 56.224 37.7968 53.28 38.4368 49.632C39.0768 45.984 39.3968 41.472 39.3968 36.096ZM60.2888 12V2.016H80.2568V72H69.2168V12H60.2888Z",
    fill: "url(#paint0_linear_1074_607)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_607",
    x1: -20,
    y1: 77,
    x2: 60.647,
    y2: 33.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.107ac225af51821e4bd0b1dce9ba930e.svg";
export { ForwardRef as ReactComponent };